var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { client as apiClient } from './client';
/** The catalog of selectable shields (the game's shields) + admin-added rows. */
export function getShields() {
    return __awaiter(this, void 0, void 0, function* () {
        return apiClient.get('/shields');
    });
}
export function createShield(data) {
    return __awaiter(this, void 0, void 0, function* () {
        return apiClient.post('/shields', data);
    });
}
export function updateShield(id, data) {
    return __awaiter(this, void 0, void 0, function* () {
        return apiClient.patch(`/shields/${id}`, data);
    });
}
export function deleteShield(id) {
    return __awaiter(this, void 0, void 0, function* () {
        yield apiClient.delete(`/shields/${id}`);
    });
}
export function restoreShield(id) {
    return __awaiter(this, void 0, void 0, function* () {
        yield apiClient.patch(`/shields/${id}/restore`);
    });
}
export function deleteShieldPermanently(id) {
    return __awaiter(this, void 0, void 0, function* () {
        yield apiClient.delete(`/shields/${id}/permanent`);
    });
}
